export default "__VITE_ASSET__CVcYSSBk__"